export default __webpack_public_path__ + "locales/vi/JavascriptSdk.json?hash=28b0220ecc02ca086ae31dac5250c8f4";